<template>
  <div id="app">
    <el-container>
      <!-- 头部导航 -->

      <el-header class="contai_header" height="11%" :style="{ background: color }">
        <Heads></Heads>
      </el-header>

      <!-- 内容栏  #303133-->
      <el-container>
        <!-- 左边栏 -->
        <el-aside width="188px" :style="{ background: color }">
          <el-row class="tac">
            <el-col>
              <el-menu
                :default-active="path"
                class="el-menu-vertical-demo"
                :background-color="color"
                text-color="#ffffff"
                active-text-color="#0fff02"
                @click="zaiD"
              >
                <!-- 线上业务 -->
                <el-submenu index="1">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>线上典当业务</span>
                  </template>
                  <el-menu-item
                    :index="item.name"
                    v-for="item in items"
                    :key="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>
                <!-- 线下业务 -->
                <el-submenu index="2">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>民品典当业务</span>
                  </template>
                  <el-menu-item
                    :index="item.name"
                    v-for="item in itemss"
                    :key="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>

                <!-- 汽车业务 -->
                <el-submenu index="3">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>汽车典当业务</span>
                  </template>
                  <el-menu-item
                    v-for="item in itemcar"
                    :index="item.name"
                    :key="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>

                <!-- 房产业务 -->
                <el-submenu index="4">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>房产典当业务</span>
                  </template>
                  <el-menu-item
                    v-for="item in house"
                    :index="item.name"
                    :key="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>

                <!-- 当品登记表 -->
                <el-menu-item index="DpRegister" @click="zaiD">
                  <i class="el-icon-s-data"></i>
                  <span slot="title">当品登记</span>
                </el-menu-item>

                <!-- 仓库管理 -->
                <el-submenu index="5">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>仓库管理</span>
                  </template>
                  <el-menu-item
                    :index="item.name"
                    v-for="item in itemcw"
                    :key="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>

                <!-- 系统设置 -->
                <el-submenu index="6">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>系统设置</span>
                  </template>
                  <el-menu-item
                    v-for="item in xtitem"
                    :key="item.name"
                    :index="item.name"
                    @click="zaiD"
                  >
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </el-submenu>

                <el-menu-item index="charged" @click="zaiD">
                  <i class="el-icon-setting"></i>
                  <span slot="title">当户资料管理</span>
                </el-menu-item>

                <el-menu-item index="kan" @click="zaiD">
                  <i class="el-icon-zoom-in"></i>
                  <span slot="title">业务综合查询</span>
                </el-menu-item>
                <el-menu-item index="flow" @click="zaiD">
                  <i class="el-icon-search"></i>
                  <span slot="title">业务流水查询</span>
                </el-menu-item>

                <el-menu-item index="coupons" @click="zaiD">
                  <i class="el-icon-s-ticket"></i>
                  <span slot="title">优惠券管理</span>
                </el-menu-item>

                <!-- 积分 -->
                <el-menu-item index="integrals" @click="zaiD">
                  <i class="el-icon-s-data"></i>
                  <span slot="title">积分管理</span>
                </el-menu-item>

                <!-- 今日金价 -->
                <el-menu-item index="realTimesGold" @click="zaiD">
                  <i class="el-icon-s-data"></i>
                  <span slot="title">每日金价</span>
                </el-menu-item>

                <!-- 商城管理 -->
                <el-menu-item index="Shops" @click="zaiD">
                  <i class="el-icon-s-cooperation"></i>
                  <span slot="title">商城管理</span>
                </el-menu-item>

                <!-- 费率调整 -->
                <!-- <el-menu-item index="InteresRate" @click="zaiD">
                  <i class="el-icon-s-tools"></i>
                  <span slot="title">费率设置</span>
                </el-menu-item> -->
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>

        <!-- 右边栏 -->
        <el-main width="90%">
          <div class="conta_right">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Heads from "@/components/Heads.vue";
export default {
  name: "Home",
  data() {
    return {
      path: this.$route.name, //this.$route.name,
      items: [
        {
          title: "在当订单",
          name: "when",
          icon: "el-icon-s-unfold",
        },
        {
          title: "逾期订单",
          name: "beo",
          icon: "el-icon-info",
        },
        {
          title: "赎回订单",
          name: "redeem",
          icon: "el-icon-s-platform",
        },
        {
          title: "绝当订单",
          name: "absolutely",
          icon: "el-icon-error",
        },
        {
          title: "待评估订单",
          name: "assessment",
          icon: "el-icon-document",
        },
        {
          title: "所有估价订单",
          name: "already",
          icon: "el-icon-star-on",
        },
        {
          title: "修改小程序金价",
          name: "modify",
          icon: "el-icon-s-claim",
        },
        {
          title: "修改滚动文字",
          name: "scrolling",
          icon: "el-icon-s-order",
        },
      ],

      itemss: [
        {
          title: "建当",
          name: "establish",
          icon: "el-icon-s-tools",
        },
        {
          title: "复核",
          name: "review",
          icon: "el-icon-s-operation",
        },
        {
          title: "当台出纳",
          name: "finance",
          icon: "el-icon-s-platform",
        },
        {
          title: "在当业务",
          name: "whens",
          icon: "el-icon-s-help",
        },
        {
          title: "赎回业务",
          name: "redeemed",
          icon: "el-icon-refresh",
        },
        {
          title: "绝当业务",
          name: "offline",
          icon: "el-icon-error",
        },
        {
          title: "回收业务",
          name: "recycle",
          icon: "el-icon-error",
        },
      ],

      itemcar: [
        {
          title: "汽车建当",
          name: "cars",
          icon: "el-icon-s-help",
        },
        {
          title: "汽车复核",
          name: "reviews",
          icon: "el-icon-s-grid",
        },
        {
          title: "在当汽车",
          name: "scars",
          icon: "el-icon-s-finance",
        },
        {
          title: "汽车赎当业务",
          name: "ransom",
          icon: "el-icon-truck",
        },
        {
          title: "汽车绝当业务",
          name: "CarForbidden",
          icon: "el-icon-document-delete",
        },
      ],

      itemcw: [
        {
          title: "入库确认",
          name: "ware",
          icon: "el-icon-edit-outline",
        },
        {
          title: "在库物品",
          name: "wares",
          icon: "el-icon-discover",
        },
        {
          title: "仓库统计",
          name: "statistics",
          icon: "el-icon-guide",
        },
      ],
      xtitem: [
        {
          title: "账号管理",
          name: "system",
          icon: "el-icon-user-solid",
        },
        {
          title: "微信通知管理",
          name: "WechatMsg",
          icon: "el-icon-user-solid",
        },
        {
          title: "典当信用查询",
          name: "printing",
          icon: "el-icon-bangzhu",
        },
        {
          title: "未更新信息客户",
          name: "test",
          icon: "el-icon-set-up",
        },
      ],
      house: [
        {
          title: "房产建当",
          name: "createHouse",
          icon: "el-icon-s-shop",
        },
        {
          title: "房产复核",
          name: "reviewHouse",
          icon: "el-icon-s-unfold",
        },
        {
          title: "在当房产",
          name: "whenHouse",
          icon: "el-icon-s-platform",
        },
        {
          title: "赎回房产业务",
          name: "redeemHouse",
          icon: "el-icon-paperclip",
        },
        {
          title: "房产绝当业务",
          name: "pawnHouse",
          icon: "el-icon-warning",
        },
      ],

      name: "超级管理员",

      color: "#38435a",
    };
  },
  components: {
    Heads,
  },
  methods: {
    zaiD(e) {
      this.$router.push({
        name: e.index,
      });
    },
    //请求背景颜色
    getColor() {},
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("headerColor").where({}).get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.color = res.data.data[0].colors;
        });
    }, 800);
  },
};
</script>
<style scoped>
.el-header {
  /* background-color: #38435a; */
  color: #333;
  text-align: center;
  line-height: 100px;
}
.el-aside {
  /* background-color: #303133; */
  color: #ffffff;
  text-align: center;
  line-height: 70px;
}

.el-main {
  background-color: #e9eef3;
  color: #444444;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.conta {
  display: flex;
  flex-direction: column;
}

.el-container {
  height: 1260px;
}
</style>
